import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    addUserBlock: {
      display: 'flex',
      justifyContent: 'flex-start',
    },
    input: {
      marginTop: '2px',
      marginRight: '8px',
      width: '100%',
    },
    addButton: {
      marginRight: '8px',
    },
    userPrincipalName: {
      fontWeight: 'bold',
      marginRight: '6px',
      fontSize: '12px',
    },
    optionLabel: {
      display: 'flex',
      marginTop: '4px',
    },
  },
  {
    name: 'AddUser',
  },
);
